// extracted by mini-css-extract-plugin
export default {"discount_head":"DiscountHead_discount_head__0Dk5x"};